import React, { Component } from 'react'
import {connect} from 'react-redux'

import { Box, Divider, Grid, Select, FormControl, InputLabel, MenuItem, Chip,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    TablePagination, CircularProgress } from '@material-ui/core'

import { Folder, Email } from '@material-ui/icons'
import { withStyles } from '@material-ui/core/styles'
import { getPresentations, selectPresentation, getAnswers, selectAnswer } from "../actions/answers";
import CancelFormButton from '../containers/CancelFormButton'
import AnswersContainer from './AnswersContainer'

// **********  STYLES ************//
const defaultBoxAbsolute = {
    position: "absolute",
    left: 0,
    top:0,
    right: 0,
    bottom: 0
}

const styles = ({
    box_view: {
        ...defaultBoxAbsolute
    },
    leftBox: {
        ...defaultBoxAbsolute,
        right: "40%"
    },
    rightBox: {
        ...defaultBoxAbsolute,
        left: "60%"
    },
    bottomBox: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0
    },
    devider: {
        position: "absolute",
        left: "60%"
    },
    titleLeft:{
        fontFamily:"Asap-Italic",
        fontSize: 22,
        color:"#666666",
        marginBottom: "20px"
    },
    presDropdown: {
        width: "100%",        
        '&>label.MuiFormLabel-root':{
          fontFamily: 'Asap-Bold',
          color: '#666666',
          fontSize: 16,
          transform: 'translate(0, -4px) scale(0.75)'
        },
        '& .MuiInputBase-input':{
          fontFamily: 'Asap-Italic',
          fontSize: 14,
          color: '#666666',
          padding: 0,
          backgroundColor: '#f5f5f5'
        },
        '& .MuiInputBase-input.MuiSelect-select': {
          backgroundColor: '#ffffff',
          border: '#707070 1px solid'
        },
        '& .MuiInput-underline:after, & .MuiInput-underline:before':{
          display: 'none'
        }
    },
    chip:{
        '&.MuiChip-root':{
            backgroundColor: 'transparent',
            height: 24
        },
        '& .MuiChip-icon, & .MuiSvgIcon-root':{
            fontSize: 18,
            color: '#666666'
        },
        '& .MuiChip-label':{
            fontFamily: 'Asap-Italic',
            fontSize: 12,
            color: '#666666',
            height: 16
        }
    },
    tableRoot:{
        width: '100%',
        marginTop: 15,
        boxShadow: 'none',
        position: 'relative',
        '& .MuiTablePagination-root':{
            '& .MuiTablePagination-toolbar': {
                minHeight: 24,
                paddingTop: 8,
                '& .MuiTypography-root':{
                    fontFamily: 'Asap-Italic',
                    color: '#333333',
                    fontWeight: 'bold',
                    fontSize: 12
                },
                '& .MuiTablePagination-actions':{
                    '& .MuiIconButton-root':{
                        padding: 4,
                        '& .MuiSvgIcon-root':{
                            width: 18,
                            height: 18
                        }
                    }
                }
            }
        }
    },
    tableContainer:{
        maxHeight: 440
    },
    table: {
        minWidth: 400,
        width: 'calc(100% - 15px)',        
        '& .MuiTableCell-root':{
            fontFamily: 'Asap-Regular',
            fontSize: 12,
            color: '#666666',
            padding: '4px 5px',
            lineHeight: 1,
            border: 'none'
        },
        '& .MuiTableCell-root.MuiTableCell-head':{
            fontSize: 14,
            fontWeight: 'bold',
            color: '#000000',
            fontFamily: 'Asap-Italic',
            backgroundColor: '#ffffff'            
        },
        '& .MuiTableCell-root.MuiTableCell-body':{
            '& .MuiSvgIcon-root':{
                display: 'block',
                width: 18,
                height: 18
            }
        }
    },
    row: {
        cursor: "pointer",
        fontFamily: 'Asap-Italic',
        fontSize: 16,
        '&.selected': {
            backgroundColor: '#cdcdcd',
            '& .MuiTableCell-root.MuiTableCell-body':{
                fontWeight: 'bold',
                borderTop: '#666666 1px solid',
                borderBottom: '#666666 1px solid',
                color: '#333333'
            },
            '& .MuiTableCell-root.MuiTableCell-body:first-child':{
                borderLeft: '#666666 1px solid',
            },
            '& .MuiTableCell-root.MuiTableCell-body:last-child':{
                borderRight: '#666666 1px solid',
            }
        },
        '&:hover':{
            backgroundColor: '#cdcdcd'
        },
        '&:nth-child(2n)':{
            backgroundColor: '#f1f1f1',
            '&:hover':{
                backgroundColor: '#cdcdcd'
            }
        }
    },
    loaderBox:{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 2,
        '& .MuiCircularProgress-root':{
            color: '#EB8023'
        }
    }
})

// **********  STYLES END *********//

const ANSWERS_PAGE_SIZE = 20

class ViewPreview extends Component {
    constructor(props){
        super(props)
    }
    
    componentDidMount(){
        const {init, settings, answers} = this.props;
        if(answers.presentations.length === 0)
            init(settings.form.FormId);        
    }

    handleChange = (event) => {
        let presentation = event.target.value;
        const { answers, selectPresentation, getAnswers, settings } = this.props;
        selectPresentation(presentation);
        if(presentation.PresentationId > 0){
            if(!answers.answers[presentation.PresentationId] || 
                !answers.answers[presentation.PresentationId].items || 
                answers.answers[presentation.PresentationId].items.length === 0){
                getAnswers(settings.form.FormId, presentation.PresentationId, 1, ANSWERS_PAGE_SIZE)
            }
        }else{
            if(answers.answers.all.items.length === 0){
                getAnswers(settings.form.FormId, presentation.PresentationId, 1, ANSWERS_PAGE_SIZE)
            }
        }

    }

    handleSelectAnswer = (event, answer) => {
        console.log("Answer Selected: ", answer)
        const {selectAnswer} = this.props
        selectAnswer(answer)
    }

    showPresValue = (item, classes) => {
        if (item.PresentationId > 0)
            return (
                <Chip
                    icon={<Folder></Folder>}
                    label={`${item.EncryptedId} - ${item.Name}`} 
                    className={classes.chip} />
            );
        else
            return (
                <Chip
                    icon={<Folder></Folder>}
                    label={`${item.Name}`}
                    className={classes.chip} />
            );
    }

    handleChangePage = (event, page) => {
        const {settings, answers, getAnswers} = this.props;        
        console.log("handleChangePage: page: ", page)
        let newPage = page + 1;
        getAnswers(settings.form.FormId, answers.selectedPresentation.PresentationId, newPage, ANSWERS_PAGE_SIZE)
    }

    formatDateTime = (datetime) => {
        let d = datetime + "Z";
        let nd = new Date(d);        
        let ds = nd.toLocaleDateString();
        let ts = nd.toLocaleTimeString();
        return `${ds} ${ts}`;
    }

    render(){
        const { answers, classes } = this.props;
        let answerObject = answers.selectedPresentation.PresentationId > 0 ? 
            answers.answers[answers.selectedPresentation.PresentationId] :
            answers.answers.all;
        return (
            <Box className={classes.box_view}>
                <Box className={classes.leftBox}>                
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Box m="10px 0" className={classes.titleLeft}>View and manage all of your form submissions</Box>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl className={classes.presDropdown}>
                                <InputLabel id="pres-label">Browser Projects</InputLabel>
                                <Select
                                    labelId="pres-label"
                                    id="pres-select"
                                    value={answers.selectedPresentation}
                                    rendervalue={(v) => this.showPresValue(v, classes)}                                    
                                    onChange={this.handleChange}
                                    label="Filter by Presentations"
                                    autoWidth
                                >
                                    <MenuItem value={answers.itemPresAll}>
                                        <Chip 
                                            icon={<Folder></Folder>}
                                            label={`${answers.itemPresAll.Name}`}
                                            className={classes.chip}
                                        />
                                    </MenuItem>
                                    {
                                        answers.presentations.map((item) => {
                                            return(
                                                <MenuItem key={item.PresentationId} value={item}>
                                                    <Chip
                                                        icon={<Folder></Folder>}
                                                        label={`${item.EncryptedId} - ${item.Name}`}
                                                        className={classes.chip}
                                                    />
                                                </MenuItem>
                                            )
                                        })
                                    }
                                    
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} >
                        <Grid item xs={11}>
                            {
                                answerObject && answerObject.items && answerObject.items.length > 0 ?
                                    <Paper className={classes.tableRoot}>
                                        <TableContainer className={classes.tableContainer}>
                                            <Table className={classes.table} stickyHeader aria-label="Answers by current form">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell></TableCell>
                                                        <TableCell>ID</TableCell>
                                                        <TableCell align="left">Date</TableCell>
                                                        <TableCell align="left">Sent To (Email)</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {answerObject.items.map((item) => (
                                                        <TableRow key={item.ResponseId} tabIndex={-1} className={answers.selectedAnswer &&
                                                            answers.selectedAnswer.ResponseId === item.ResponseId ?
                                                            classes.row + " selected" : classes.row}
                                                            onClick={(e) => this.handleSelectAnswer(e, item)}>
                                                            <TableCell><Email></Email></TableCell>
                                                            <TableCell>{item.ResponseId}</TableCell>
                                                            <TableCell align="left">{this.formatDateTime(item.Date)}</TableCell>
                                                            <TableCell align="left">{item.EmailSender}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <TablePagination
                                            count={answerObject.total}
                                            component="div"
                                            rowsPerPage={ANSWERS_PAGE_SIZE}
                                            page={answerObject.page - 1}
                                            onChangePage={this.handleChangePage}
                                            rowsPerPageOptions={[]}
                                        ></TablePagination>
                                        {
                                            answers.loader ? 
                                                <Box className={classes.loaderBox} display="flex" justifyContent="center" alignItems="center">
                                                    <CircularProgress />
                                                </Box>
                                                :
                                                <></>
                                        }                                        
                                    </Paper>
                                     :
                                    <></>
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Box className={classes.bottomBox} m="5px 0 5px 0px">
                    <Grid item xs={2}>
                        <CancelFormButton />
                    </Grid>
                </Box>

                <Divider orientation="vertical" className={classes.devider}></Divider>
                <Box className={classes.rightBox}>
                    <AnswersContainer></AnswersContainer>
                </Box>                                  
            </Box>
        )
    }
}

const mapStateToProps = state => ({
    answers: state.answers,
    settings: state.settings    
})

const mapDispatchToProps = dispatch => ({
    init: formId => dispatch(getPresentations(formId)),
    selectPresentation: presentation => dispatch(selectPresentation(presentation)),
    getAnswers: (formId, presId, page, pageSize) => dispatch(getAnswers(formId, presId, page, pageSize)),
    selectAnswer: item => dispatch(selectAnswer(item))
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ViewPreview))